import { QrcodeOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import styles from './styles.module.css';

export const InvalidToken = () => {
  return (
    <div className={styles.messageContainer}>
      <p className={`${styles.mainMessage} ${styles.bold} ${styles.textCenter}`}>
        Verifique seu link ou peça para o organizador do evento enviar novamente.
      </p>
    </div>
  );
};

export const CredentialNotValid = () => {
  return (
    <div className={styles.messageContainer}>
      <p className={`${styles.mainMessage} ${styles.marginBottom} ${styles.bold} ${styles.textCenter}`}>
        Seu acesso como credenciador foi encerrado.
      </p>

      <p className={`${styles.message}  ${styles.textCenter}`}>
        O evento associado a este link já foi encerrado. Para mais informações, entre em contato com a organização do
        evento.
      </p>
    </div>
  );
};

export const NotAvailableYet = () => {
  return (
    <div className={styles.messageContainer}>
      <p className={`${styles.mainMessage} ${styles.marginBottom} ${styles.bold} ${styles.textCenter}`}>
        O check-in ainda não está disponível.
      </p>

      <p className={`${styles.message}  ${styles.textCenter}`}>
        O Credenciamento será liberado nos dias do evento, por favor, aguarde.
      </p>
    </div>
  );
};

export const LoadingCredential = () => {
  return (
    <div className={styles.messageContainer}>
      <div className={styles.messageAndQRcode}>
        <QrcodeOutlined className={styles.QRIcon} />
        <p className={styles.messageLeft}>
          Estamos validando o credenciador e carregando o leitor de QR Code.
          <br />
          Em instantes o leitor será exibido.
        </p>
      </div>
    </div>
  );
};

export const CheckinFaq = () => {
  return (
    <div className={styles.faqWrapper}>
      <div className={styles.messageContainer}>
        <p className={`${styles.mainMessage} ${styles.bold}`}>Quer entender melhor o processo de credenciamento?</p>
        <p className={styles.messageLeft}>
          Acesse nossa{' '}
          <a href='' target='_blank'>
            FAQ
          </a>{' '}
          e veja todos os feedbacks que podem aparecer durante o check-in.
        </p>
        <a>
          <Button type='primary' className={styles.faqButton}>
            Acessar FAQ
          </Button>
        </a>
      </div>
    </div>
  );
};

export const Warning = ({ onOk }: { onOk: () => void }) => {
  return (
    <div className={styles.messageContainer}>
      <p className={`${styles.mainMessage} ${styles.marginBottom} ${styles.bold} ${styles.textCenter}`}>
        Acessando check-in como administrador, por segurança, não compartilhe esse link com ninguém. O acesso de
        produtor permite utilizar o check-in mesmo antes do evento começar. Para credenciadores, o acesso é liberado
        apenas no dia do evento.
      </p>
      <Button type='primary' onClick={onOk} className={styles.warningButton}>
        Ok
      </Button>
    </div>
  );
};
